import { initNav, initScrollAnimations } from './nav';
import { initPoemFilters } from './poems';

initNav();
initScrollAnimations();
initPoemFilters();
